/*!
 * Cartzilla | Multipurpose E-Commerce Bootstrap HTML Template
 * Copyright 2025 Coderthemes
 * Theme scripts
 *
 * @author Coderthemes
 * @version 1.0.0
 */

// Clear customer data from a previous session before anything reads from localStorage
import './module/customer-storage.js'

// Stimulus
import '../../stimulus_bootstrap.js'

// Disable submit buttons once a form is posted
import '../../js/utilities/form-submit-guard.js'

// Styling
import '@algolia/autocomplete-theme-classic'
import '../scss/theme.scss'
import '../icons/cartzilla-icons.min.css'

// bootstrap
import 'bootstrap/js/dist/alert.js'
import 'bootstrap/js/dist/offcanvas.js'
import 'bootstrap/js/dist/dropdown.js'

// Components
import './components/theme-switcher.js'
import './components/sticky-navbar.js'
import './components/carousel.js'
import './components/lightbox.js'
import './components/countdown.js'
import './components/range-slider.js'
import './components/password-toggle.js'
import './components/count-input.js'
import './components/input-formatter.js'
import './components/form-validation.js'
import './components/autofocus.js'
import './components/scroll-top-button.js'
import './components/select-box.js'
import './components/dropdown-hover.js'
import './components/tooltip.js'
import './components/collapse.js'
import './components/popover.js'
import './components/filter-list.js'
import './components/date-picker.js'
import './components/master-checkbox.js'
import './components/binded-label.js'
import './components/image-zoom.js'
import './components/code-highlight.js'
import './components/copy-text.js'
import './components/chart.js'
import './components/vat-toggle.js'
import './components/algolia-autocomplete.js'
import './components/search-bar.js'

import RemoteSwiper from './components/remote-swiper.js'
import AddToCartHandler from './components/add-to-cart-handler.js'
import RemoteModal from '../../js/utilities/remote-modal.js'
import ProductConfigurator from './components/product-configurator.js'
import SearchableSelect from './components/searchable-select.js'
import ShoppingCartUserInput from './components/shopping-cart-user-input.js'
import CartCounter from './components/cart-counter.js'
import ServiceHours from './components/service-hours.js'
import CategoryDropdown from './components/category-dropdown.js'

// Register Datalayer listener for tracking events
import './components/datalayer.js'
import './components/cookiefirst-advertising-consent.js'

const initAddToCartHandler = () => {
  const modalElement = document.querySelector('[data-remote-modal]')

  if (!modalElement) {
    return
  }

  const remoteModal = new RemoteModal(modalElement)
  const addToCartHandler = new AddToCartHandler(remoteModal)

  addToCartHandler.init()
}

const initProductConfigurator = () => {
  const productConfigurator = new ProductConfigurator()

  productConfigurator.init()
}

const initSearchableSelect = () => {
  const searchableSelect = new SearchableSelect()

  searchableSelect.init()
}

const initRemoteSwiper = () => {
  const remoteSwiper = new RemoteSwiper()

  remoteSwiper.init()
}

const initShoppingCartUserInput = () => {
  const shoppingCartUserInput = new ShoppingCartUserInput()

  shoppingCartUserInput.init()
}

const initPolyestershoppen = () => {
  initAddToCartHandler()
  initProductConfigurator()
  initSearchableSelect()
  initShoppingCartUserInput()
  initRemoteSwiper()
  CartCounter.init()
  ServiceHours.init()
  CategoryDropdown.init()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPolyestershoppen, { once: true })
} else {
  initPolyestershoppen()
}

// HTMX
import 'htmx.org'
